type cartesianType = (data: any[]) => any[];

const cartesian: cartesianType = data =>
  data?.reduce((a: [], b: []) => a.flatMap(d => b.map(e => [d, e].flat())));

export default cartesian;
